import React from "react";
import { useNavigate } from "react-router-dom";
function Container() {

    const navigate = useNavigate();
    const movetodashboard = (e) => {
        e.preventDefault();
        navigate("/dashboard");
    }

    return (
        <div class="pc-container">
            <div class="pc-content">
                <div class="page-header">
                    <div class="page-block">
                        <div class="row align-items-center">
                            <div class="col-md-12 breadcrumb">
                                <div class="page-header-title">
                                    <h4 class="m-b-10">404 Error Page</h4>
                                </div>
                                <ul class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="" onClick={movetodashboard}>Home</a></li>
                                    <li class="breadcrumb-item"><a href="">404 Error Page</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style={{ padding: '0px' }}>
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <section class="content">
                            <div class="error-page">
                                <h1 class="headline text-yellow-500 mb-4"> 404</h1>

                                <div class="error-content">
                                    <h3><i class="fa fa-warning text-yellow-500 mb-3"></i> Oops! Page not found.</h3>

                                    <p>
                                        We could not find the page you were looking for.
                                        Meanwhile, you may <a href="" onClick={movetodashboard}>return to dashboard</a> or try using the search form.
                                    </p>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Container